// extracted by mini-css-extract-plugin
export default {"singleLineInput":"Security_singleLineInput__jTRrQ","button":"Security_button__3Pm1l"};